import BaseRequestModel from '../../../../network/interface/BaseRequestModel';

export default class FormResendOTPRequest implements BaseRequestModel {
	private readonly _countryCode: string | undefined;
	private readonly _phoneNumber: string | undefined;
	private readonly _email: string | undefined;

	constructor({
		countryCode,
		phoneNumber,
		email,
	}: {
		countryCode?: string;
		phoneNumber?: string;
		email?: string;
	}) {
		this._countryCode = countryCode;
		this._phoneNumber = phoneNumber;
		this._email = email;
	}

	/**
	 * This method is used to get the request body to be sent
	 * in /minerva/moSignUp/sendOneTimePassword API call for composite form verification
	 * @returns {FormResendOTPRequestType}
	 */
	getRequestDataObject(): FormResendOTPRequestType {
		const toReturn: FormResendOTPRequestType = {
			source: 'FORM_RESPONSE',
		};
		if (this._countryCode != null && this._phoneNumber != null) {
			toReturn.countryCode = this._countryCode;
			toReturn.phoneNumber = this._phoneNumber;
		} else {
			toReturn.email = this._email;
		}
		return toReturn;
	}
}

export type FormResendOTPRequestType = {
	countryCode?: string;
	phoneNumber?: string;
	email?: string;
	source: string;
};
